var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 69 60",
    style: {
      width: "1.15em"
    },
    fill: "#AEAEB3"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.49 59.81L.154.342h68.676L34.491 59.81z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjkgNjAiIHN0eWxlPSJ3aWR0aDogMS4xNWVtOyIgZmlsbD0icmdiKDE3NCwgMTc0LCAxNzkpIj4KICA8cGF0aCBkPSJNMzQuNDkwOCA1OS44MTAyTDAuMTUyNTg4IDAuMzQyMDQxSDY4LjgyOUwzNC40OTA4IDU5LjgxMDJaIiBmaWxsPSJyZ2IoMTc0LCAxNzQsIDE3OSkiPjwvcGF0aD4KPC9zdmc+";
export { SvgDown as ReactComponent };